import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import styles from './HomePage.module.scss';
import SendMessage from '../../assets/send-fill.svg';
import Copy from '../../assets/copy.svg';
import Delete from '../../assets/delete.svg';
import Select from '../../assets/check-all.svg';
import Change from '../../assets/change.svg';
import Reply from '../../assets/reply-fill.svg';
import CallIcon from '../../assets/telephone-fill.svg';
import HeartIcon from '../../assets/heart.svg';
import { useLayoutEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from '../../hooks/hook';
import { addSelectedMessage, changeMessage, closeBar, closeMenu, isSendMessage, setReplyToMessage, setShowCheckbox, setTempChat } from '../../store/slices/appSlice';
import { messagesAPI } from '../../API/api';
import { useTypedTranslation } from '../../hooks/useTypedTranslation';
import { createPortal } from 'react-dom';
import { openModalCalls } from '../../store/slices/callsSlice';
import { getContextMenuPosition } from '../../utils/utils';
import DialogComponent, { LayoutDialogList } from '../Settings/DialogComponent';
import { Virtuoso } from 'react-virtuoso';
import { clickType } from '../../constants/constants';
const ANIMATION_DURATION = 190;
// const reactions = ['🤡', '👍', '👎', '👋', '🙏', '😄', '😡'];
const reactions = ['🤡', '👍', '👎', '👋', '🙏', '😄'];
const UserReaction = ({ reaction }) => {
    const dispatch = useAppDispatch();
    const currentUser = useAppSelector(state => state.app.currentUser);
    const handleClickName = (e) => {
        e.stopPropagation();
        if (currentUser.uid === reaction.sender.uid)
            return;
        dispatch(closeMenu(null));
        dispatch(setTempChat(reaction.sender));
    };
    return (_jsxs("li", { style: { margin: '4px 8px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }, onClick: handleClickName, children: [_jsx("span", { style: { fontSize: '1.1rem', margin: '2px 0px' }, children: reaction.sender.displayName }), _jsx("div", { style: { display: 'flex', alignItems: 'center' }, children: _jsx("div", { children: _jsx("span", { children: reaction.reaction }) }) })] }));
};
const ReactionsList = ({ list }) => {
    return (_jsx(LayoutDialogList, { children: _jsx(Virtuoso, { style: { height: '100%' }, data: list, totalCount: list.length, itemContent: (index, item) => (_jsx(UserReaction, { reaction: item })) }) }));
};
const ContextMenu = ({ closeContextMenu, isOwner, message, isForwarder, currentUser, positionClick }) => {
    var _a;
    const dispatch = useAppDispatch();
    const chat = useAppSelector(state => state.app.selectedChat);
    const isFavorites = useAppSelector(state => state.app.isFavorites);
    const lastMessageInChannel = useAppSelector(state => { var _a; return (_a = state.app.selectedChannel) === null || _a === void 0 ? void 0 : _a.lastMessage; });
    const [openListReaction, setOpenListReaction] = useState(false);
    const isCallMessage = !!(message === null || message === void 0 ? void 0 : message.callStatus);
    const isChannel = !!(chat === null || chat === void 0 ? void 0 : chat.channel);
    const { t } = useTypedTranslation();
    const portalRootRef = useRef(typeof document !== "undefined" ? document.body : null);
    const [menuState, setMenuState] = useState({
        offset: { top: 0, left: 0 },
        open: false
    });
    const positionMenu = {
        position: 'relative',
        top: menuState.offset.top + 'px',
        left: menuState.offset.left + 'px',
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
        width: 'fit-content'
    };
    const copyMessage = () => {
        navigator.clipboard.writeText(message.message);
    };
    const change = () => {
        dispatch(changeMessage(message));
    };
    const selectSeveral = () => {
        dispatch(setShowCheckbox(true));
    };
    const deleteMessage = () => {
        messagesAPI.deleteMessage({
            chat,
            message,
            isFavorites,
            updateLastMessage: (lastMessageInChannel === null || lastMessageInChannel === void 0 ? void 0 : lastMessageInChannel.messageID) === message.messageID
        })
            .catch((error) => console.error("Ошибка при удалении сообщения:", error));
    };
    const forwardMessage = () => {
        dispatch(addSelectedMessage(message));
        dispatch(isSendMessage(true));
        dispatch(closeBar(clickType.CONTACTS));
    };
    const close = (e) => {
        var _a;
        if (openListReaction)
            return;
        setMenuState(prev => (Object.assign(Object.assign({}, prev), { open: false })));
        (_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener("transitionend", () => closeContextMenu(e), { once: true });
    };
    const replyToMessage = () => {
        dispatch(setReplyToMessage(message));
    };
    const callBack = () => {
        dispatch(openModalCalls({
            mode: null,
            callerUid: chat.uid,
            roomId: null,
            callInfo: { caller: currentUser, callee: chat }
        }));
    };
    const setReactions = (reaction) => {
        messagesAPI.setReaction({
            chat,
            reaction: { reaction, sender: currentUser },
            messageID: message.messageID,
            isFavorites
        });
    };
    const showReactions = (e) => {
        e.stopPropagation();
        setOpenListReaction(true);
    };
    const reactionsNode = (_jsx("div", { className: classNames(styles.reactions, { [styles.reactions_open]: menuState.open }), children: reactions.map((emoji, idx) => (_jsx("span", { className: styles.reactionItem, onClick: () => setReactions(emoji), children: emoji }, idx))) }));
    const menuRef = useRef(null);
    useLayoutEffect(() => {
        if (menuRef.current) {
            const offset = getContextMenuPosition({
                clickX: positionClick.left,
                clickY: positionClick.top,
                menuWidth: menuRef.current.clientWidth,
                menuHeight: menuRef.current.clientHeight
            });
            setMenuState({ offset, open: true });
        }
    }, []);
    const menu = (_jsxs("div", { className: classNames(styles.cover, { [styles.showContextMenu]: menuState.open }), onClick: close, onContextMenu: close, children: [_jsxs("div", { style: positionMenu, ref: menuRef, children: [reactionsNode, _jsx("div", { className: classNames(styles.contextMenu, { [styles.contextMenu_open]: menuState.open }), children: _jsxs("ul", { children: [isChannel && ((_a = message === null || message === void 0 ? void 0 : message.reactions) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
                                    _jsxs("li", { onClick: showReactions, children: [_jsx(HeartIcon, {}), _jsx("span", { children: t('reactions') })] }), (message === null || message === void 0 ? void 0 : message.callStatus) &&
                                    _jsxs("li", { onClick: callBack, children: [_jsx(CallIcon, {}), _jsx("span", { children: t('call.callback') })] }), (chat === null || chat === void 0 ? void 0 : chat.channel) ?
                                    isOwner ? _jsxs("li", { onClick: replyToMessage, children: [_jsx(Reply, {}), _jsx("span", { children: t('answer') })] }) : null
                                    :
                                        _jsxs("li", { onClick: replyToMessage, children: [_jsx(Reply, {}), _jsx("span", { children: t('answer') })] }), !(message === null || message === void 0 ? void 0 : message.callStatus) && _jsxs("li", { onClick: forwardMessage, children: [_jsx(SendMessage, {}), _jsx("span", { children: t('forward') })] }), !(message === null || message === void 0 ? void 0 : message.callStatus) && _jsxs("li", { onClick: copyMessage, children: [_jsx(Copy, {}), _jsx("span", { children: t('copyText') })] }), isOwner && !isForwarder && !isCallMessage &&
                                    _jsxs("li", { onClick: change, children: [_jsx(Change, {}), _jsx("span", { children: t('change') })] }), (chat === null || chat === void 0 ? void 0 : chat.channel) ?
                                    isOwner ? _jsxs("li", { onClick: deleteMessage, children: [_jsx(Delete, {}), _jsx("span", { children: t('delete') })] }) : null
                                    :
                                        _jsxs("li", { onClick: deleteMessage, children: [_jsx(Delete, {}), _jsx("span", { children: t('delete') })] }), _jsxs("li", { onClick: selectSeveral, className: classNames(styles.selectSeveral), children: [_jsx(Select, {}), _jsx("span", { children: t('selectSeveral') })] })] }) })] }), _jsx(DialogComponent, { isOpen: openListReaction, onClose: setOpenListReaction, children: _jsx(ReactionsList, { list: message === null || message === void 0 ? void 0 : message.reactions }) })] }));
    console.log('render contextmenu');
    return (createPortal(menu, portalRootRef.current));
};
export default ContextMenu;
